"use client";

import { Blurhash } from "react-blurhash";

type Props = {
  hash?: string;
  width?: string | number;
  height?: string | number;
  borderRadius?: number;
};

export default function BlurhashPlaceholder({
  hash,
  width = "100%",
  height = 320,
  borderRadius = 0,
}: Props) {
  if (!hash) {
    return (
      <div
        style={{
          width,
          height,
          borderRadius,
          background: "linear-gradient(135deg, #ececec, #d9d9d9)",
        }}
      />
    );
  }

  return (
    <div style={{ width, height, overflow: "hidden", borderRadius }}>
      <Blurhash
        hash={hash}
        width="100%"
        height="100%"
        resolutionX={32}
        resolutionY={32}
        punch={1}
      />
    </div>
  );
}
